import { createContext } from "react";

const LanguageContext = createContext({
      
    language: false
})

export default LanguageContext